import React from "react";
import { Button, Form, Heading, Modal, TextInput } from "blueprints2";
import { FormattedMessage } from "react-intl";

function GenerateToken({
  visible,
  setVisible,
  values,
  generateToken,
  modalError,
}) {
  return (
    <Modal isVisible={visible} onClose={() => setVisible(false)}>
      <Heading level={3}>
        <FormattedMessage id="applications.form.token.title" />
      </Heading>

      <Form values={values} onSubmit={(e) => generateToken(e)}>
        <TextInput
          id="scope-sid"
          hasError={!!modalError}
          helperText={modalError}
          label={<FormattedMessage id="applications.form.scope" />}
          name="sid"
        />

        <Button type="submit">
          <FormattedMessage id="applications.form.token.submit" />
        </Button>
        <Button isSecondary onClick={() => setVisible(false)}>
          <FormattedMessage id="applications.form.cancel" />
        </Button>
      </Form>
    </Modal>
  );
}

export default GenerateToken;
